import axios from "axios";
import { APP_API_V1_BASE, APP_INVENTORY_API_BASE, APP_MANUFACTURING_API_BASE } from "../../../config/api";

export const MANUFACTURING_API = APP_MANUFACTURING_API_BASE;
export const INVENTORY_API = APP_INVENTORY_API_BASE;
export const DEVICE_TYPES_API = `${APP_API_V1_BASE}/device-types`;

export function buildAuthHeaders(token, activeOrg) {
  return {
    Authorization: `Bearer ${token}`,
    ...(activeOrg?.id ? { "X-Org-ID": activeOrg.id } : {}),
  };
}

export async function getRequest(url, token, activeOrg, config = {}) {
  const res = await axios.get(url, {
    ...config,
    headers: {
      ...buildAuthHeaders(token, activeOrg),
      ...(config.headers || {}),
    },
  });
  return res.data;
}

export async function postRequest(url, body, token, activeOrg, config = {}) {
  const res = await axios.post(url, body, {
    ...config,
    headers: {
      ...buildAuthHeaders(token, activeOrg),
      ...(config.headers || {}),
    },
  });
  return res.data;
}

export async function patchRequest(url, body, token, activeOrg, config = {}) {
  const res = await axios.patch(url, body, {
    ...config,
    headers: {
      ...buildAuthHeaders(token, activeOrg),
      ...(config.headers || {}),
    },
  });
  return res.data;
}

export async function deleteRequest(url, token, activeOrg, config = {}) {
  const res = await axios.delete(url, {
    ...config,
    headers: {
      ...buildAuthHeaders(token, activeOrg),
      ...(config.headers || {}),
    },
  });
  return res.data;
}

export function getErrorMessage(error, fallback = "Request failed") {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    fallback
  );
}
